import React from 'react';
import reqwest from 'reqwest';
import ReactTable from 'react-table';

import settings from '../../../../../settings';

import Loader from '../../../../components/Loader';
import Button from '../../../../components/Button';
import RightSide from '../../../../components/FormArea/RightSide';
import ContentBox from '../../../../components/FormArea/ContentBox';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

class EMailClientOverview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      eMailClientList: [],
      loading: true,
    };

    reqwest({
      method: 'get',
      url: settings.systemmanagement.emailclient.getList,
      contentType: 'json',
      data: {
        Token: localStorage.getItem('token'),
      },
    }).then(emailClientResponse => {
      const eMailClientList = JSON.parse(emailClientResponse).filter(emailclient => {
        return emailclient?.Params?.Guid !== '';
      });

      this.setState({
        eMailClientList,
        loading: false,
      });
    });
  }

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <>
        <div className='FormArea-Form-Left'>
          <ContentBox title='E-Mail Nutzer'>
            <ReactTable
              getTrProps={(_, { original }) => ({
                onClick: () => this.props.history.replace(`${this.props.match.url}/${original.Params.Guid}`),
              })}
              data={this.state.eMailClientList}
              pageSize={this.state.eMailClientList.length}
              noDataText='Es liegen keine Nutzer vor.'
              columns={[
                {
                  Header: 'Nutzer',
                  accessor: 'Params.ClientName',
                },
              ]}
            />
          </ContentBox>
        </div>
        <RightSide>
          <Button big icon={faPlus} to={`${this.props.match.url}/new`} replace>
            Neuer EMail Nutzer
          </Button>
        </RightSide>
      </>
    );
  }
}

export default EMailClientOverview;
